import React, { Fragment, useState, useEffect } from 'react';
import { UncontrolledAlert, Alert, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './InlineAlert.css';

const defaultText = `Unable to complete your request. Please try again later or contact Customer
Care any time at:`;

const InlineAlert = ({
  baseText = null,
  boldTitle = true,
  className = '',
  color = 'danger',
  icon = 'exclamation-triangle',
  showPhones = true,
  secondaryText = null,
  titleText = null,
  uncontrolled = false
}) => {
  const [showMore, setShowMore] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const toggleText = () => setShowMore(!showMore);

  const displayText = baseText !== null ? baseText : defaultText;

  useEffect(() => {
    if (baseText !== null && secondaryText !== null) {
      if (baseText.length > 150 || secondaryText.length > 150) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    } else {
      setShowButton(false);
    }
  }, [baseText, secondaryText]);

  const alertContent = (
    <div className="inline-alert-container">
      <span><FontAwesomeIcon icon={icon} /></span>
      <div>
        {titleText && (
          <p className="mb-0">
            {boldTitle ? <strong>{titleText}</strong> : titleText}
          </p>
        )}
        {displayText !== '' && (
          <p className={`mb-0 text-break d-flex align-items-center ${showMore ? ' text-truncate' : ''}`}>
            {displayText}
          </p>
        )}
        {secondaryText && (
          <div>
            <p className={`mb-0 text-break ${showMore ? ' text-truncate' : ''}`}>
              {secondaryText}
            </p>
            {showButton && (
            <Button
              className="mx-0 p-0"
              color="link"
              onClick={toggleText}
            >
              {showMore ? 'Show More...' : 'Show Less...'}
            </Button>
            )}
          </div>

        )}
        {showPhones && (
          <Fragment>
            <p className="mb-0">North America: 617-746-9800</p>
            <p className="mb-0">Europe: +44 01983 559850</p>
            <p className="mb-0">Australia: +61-2-8310-4003</p>
          </Fragment>
        )}
      </div>
    </div>
  );

  return (
    <Fragment>
      {uncontrolled && <UncontrolledAlert className={className} color={color}>{alertContent}</UncontrolledAlert>}
      {!uncontrolled && <Alert className={className} color={color}>{alertContent}</Alert>}
    </Fragment>
  );
};

export default InlineAlert;
